import React from "react"

const FacebookIcon = (props) => (
	<svg width={props.size} height={props.size} fill={props.color} stroke={props.color} viewBox="0 0 32 32">
		<path d="M17.996 32h-5.996v-16h-4v-5.514l4-0.002-0.007-3.248c0-4.498 1.22-7.236 6.519-7.236h4.412v5.515h-2.757c-2.064 0-2.163 0.771-2.163 2.209l-0.008 2.76h4.959l-0.584 5.514-4.37 0.002-0.004 16z" />
	</svg>
)

export default FacebookIcon
